import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  deleteNarratives,
  readNarrativeItems,
  readNarrativePrompts,
  readFlow,
  shareNarrativeWithUsers,
  shareNarrativeWithClientGroup,
  updateNarrativeName,
} from '@api/narratives';

import Delete from '../../components/ListPage/components/ActionsToolbar/components/Delete';
import Details from '../../components/ListPage/components/ActionsToolbar/components/Details';
import ItemAnswers from '../../components/ItemAnswers';
import FlowDownload from '../../components/ListPage/components/ActionsToolbar/components/FlowDownload';
import ListPage from '../../components/ListPage';
import ModalBuildNarrative from '../../../Narratives/components/ModalBuildNarrative';
import Rename from '../../components/ListPage/components/ActionsToolbar/components/Rename';
import Reprompt from '../../components/ListPage/components/ActionsToolbar/components/Reprompt';
import Share from '../../components/ListPage/components/ActionsToolbar/components/Share';

import { FILTER_OPTIONS, ITEM_COLUMNS } from './utilities/helpers';

const Narratives = () => {
  const navigate = useNavigate();
  const [selectedFlow, setSelectedFlow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const narrativeRoute = useMemo(() => {
    if (!selectedFlow) return {};
    return {
      id: selectedFlow?.narrativeId,
      name: selectedFlow?.narrativeName,
      path: `/dashboard/narrative/${selectedFlow?.narrativeId}`,
    };
  }, [selectedFlow]);

  const handleReprompt = (flow) => {
    setSelectedFlow(flow);
    setIsModalOpen(true);
  };
  return (
    <>
      <ListPage
        filterOptions={FILTER_OPTIONS}
        itemActions={[
          <Details />,
          <Rename
            type="Narrative"
            updateName={({ name, row }) => updateNarrativeName({ id: row.id, name })}
          />,
          <Reprompt handleReprompt={handleReprompt} />,
          <FlowDownload />,
          <Share
            shareWithClient={shareNarrativeWithClientGroup}
            shareWithUsers={shareNarrativeWithUsers}
          />,
          <Delete
            deleteItems={(selectedRows) =>
              deleteNarratives({ ids: selectedRows.map(({ id }) => id) })
            }
          />,
        ]}
        itemColumns={ITEM_COLUMNS}
        onCreate={() => navigate('/dashboard/narratives')}
        readItems={readNarrativeItems}
        renderRowExpanded={({ row }) => (
          <ItemAnswers
            item={row?.original}
            readItemAnswers={readFlow}
            readPrompts={readNarrativePrompts}
            type="Flow"
          />
        )}
        type="Narrative"
        workspace="Narratives"
      />
      {isModalOpen && (
        <ModalBuildNarrative
          flowId={selectedFlow?.id}
          route={narrativeRoute}
          setIsModalOpen={(value) => {
            setSelectedFlow(null);
            setIsModalOpen(value);
          }}
        />
      )}
    </>
  );
};

export default Narratives;
